import type { StreamRouteStatus, StreamStatus } from '@/types/events'

export type StreamPresencePhase =
  | 'waiting'
  | 'starting'
  | 'ready'
  | 'connecting'
  | 'reconnecting'
  | 'live'
  | 'stopping'
  | 'error'

export interface StreamPresenceState {
  phase: StreamPresencePhase
  label: string
  canStop: boolean
  isLive: boolean
  isWaiting: boolean
  isTransitional: boolean
  showMetrics: boolean
}

export function deriveStreamPresenceState(
  status?: StreamStatus,
  hasTrack = false,
  routeStatus?: StreamRouteStatus | null
): StreamPresenceState {
  if (hasTrack && status !== 'stopping' && status !== 'error') {
    return presenceState('live', 'Live')
  }

  switch (status) {
    case 'active':
      if (routeStatus === 'grace') {
        return presenceState('reconnecting', 'Waiting')
      }

      return presenceState('ready', 'Ready')
    case 'provisioning':
      return presenceState('starting', 'Starting stream')
    case 'stopping':
      return presenceState('stopping', 'Stopping stream')
    case 'error':
      return presenceState('error', 'Stream error')
    case 'created':
    case 'stopped':
    case 'idle':
    default:
      return presenceState('waiting', 'Waiting for camera')
  }
}

function presenceState(
  phase: StreamPresencePhase,
  label: string
): StreamPresenceState {
  return {
    phase,
    label,
    canStop: phase === 'starting' || phase === 'ready' || phase === 'connecting' || phase === 'reconnecting' || phase === 'live',
    isLive: phase === 'live',
    isWaiting: phase === 'waiting',
    isTransitional: phase === 'starting' || phase === 'connecting' || phase === 'reconnecting' || phase === 'stopping',
    showMetrics: phase === 'connecting' || phase === 'reconnecting' || phase === 'live',
  }
}
